import React from "react";
import DealerActivationPayment from "../components/dealer/DealerActivationPayment";

const DealerActivation: React.FC = () => {
  return <DealerActivationPayment />;
};

export default DealerActivation;
